import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface CartItem {
  id: number;
  brand: string;
  article: string;
  name: string;
  quantity: number;
  price_uah: number;
  price_usd: number;
  buy_price_usd: number;
  base_currency: string;
  root_supplier: string;
  supplier_code: string;
  supplier_real: string;
  weight: number;
  delivery_days: number;
  delivery_type: string;
}

interface CartState {
  items: CartItem[];
  addToCart: (item: Omit<CartItem, 'id'>) => void;
  removeFromCart: (id: number) => void;
  updateQuantity: (id: number, quantity: number) => void;
  clearCart: () => void;
}

export const useCartStore = create<CartState>()(
  persist(
    (set) => ({
      items: [],
      
      addToCart: (newItem) => set((state) => {
        // Если деталь уже есть в корзине - просто увеличиваем количество
        const existing = state.items.find((i) => i.article === newItem.article);
        if (existing) {
          return {
            items: state.items.map((i) =>
              i.article === newItem.article 
                ? { ...i, quantity: i.quantity + newItem.quantity } 
                : i
            ),
          };
        }
        // Если нет - добавляем новую деталь и генерируем уникальный ID
        return { items: [...state.items, { ...newItem, id: Date.now() }] };
      }),
      
      removeFromCart: (id) => set((state) => ({
        items: state.items.filter((i) => i.id !== id),
      })),
      
      updateQuantity: (id, quantity) => set((state) => ({
        items: state.items.map((i) => (i.id === id ? { ...i, quantity } : i)),
      })),
      
      clearCart: () => set({ items: [] }),
    }),
    {
      name: 'autologistic-cart', // Имя ключа в localStorage браузера
    }
  )
);
